module.exports = __webpack_public_path__ + "static/media/logo_menu.b3a45bb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_menu.png
// module id = 1679
// module chunks = 0